import clsx from 'clsx';

export default function LogoSquare({ size, className }: { size?: 'sm' | undefined; className?: string }) {
  return (
    <div
      className={clsx(
        'flex flex-none items-center justify-center',
        className,
        {
          'h-[45px] w-auto': !size,
          'h-[35px] w-auto': size === 'sm'
        }
      )}
    >
      <img
        src="/assets/images/Shoplinkpng.png"
        alt="ShopLink Logo"
        className={clsx('object-contain h-full w-auto', {
          'max-h-[45px]': !size,
          'max-h-[35px]': size === 'sm'
        })}
      />
    </div>
  );
}



